import { createRoot } from "react-dom/client";
import { NuqsAdapter } from "nuqs/adapters/react-router";
import App from "./App.tsx";
import "./index.css";
import {
  backButton,
  init,
  mainButton,
  miniApp,
  popup,
  swipeBehavior,
  themeParams,
} from "@tma.js/sdk-react";

init();
miniApp.mount();
backButton.mount();
mainButton.mount();
themeParams.mount();
popup.isSupported();
swipeBehavior.mount();
createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <NuqsAdapter>
    <App />
  </NuqsAdapter>,
  // </StrictMode>,
);
